import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toNotBlankString1ovj48s0kinvm as toNotBlankString } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { PlayerId3vdbn0bzxjwb4 as PlayerId } from './PlayerId.mjs';
import { Badge_Default_getInstance1t7libtu7t8ty as Badge_Default_getInstance } from './Badge.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_defaultPlayer() {
  _init_properties_Player_kt__qi83pd();
  return defaultPlayer;
}
var defaultPlayer;
var PlayerClass;
function Player() {
  if (PlayerClass === VOID) {
    class $ {
      constructor(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        this.q2b_1 = id;
        this.r2b_1 = badge;
        this.s2b_1 = name;
        this.t2b_1 = email;
        this.u2b_1 = callSignAdjective;
        this.v2b_1 = callSignNoun;
        this.w2b_1 = imageURL;
        this.x2b_1 = avatarType;
        this.y2b_1 = additionalEmails;
      }
      q2e(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        return new (Player())(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      r2e(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails, $super) {
        id = id === VOID ? this.q2b_1 : id;
        badge = badge === VOID ? this.r2b_1 : badge;
        name = name === VOID ? this.s2b_1 : name;
        email = email === VOID ? this.t2b_1 : email;
        callSignAdjective = callSignAdjective === VOID ? this.u2b_1 : callSignAdjective;
        callSignNoun = callSignNoun === VOID ? this.v2b_1 : callSignNoun;
        imageURL = imageURL === VOID ? this.w2b_1 : imageURL;
        avatarType = avatarType === VOID ? this.x2b_1 : avatarType;
        additionalEmails = additionalEmails === VOID ? this.y2b_1 : additionalEmails;
        return $super === VOID ? this.q2e(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) : $super.q2e.call(this, id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      toString() {
        return 'Player(id=' + this.q2b_1.toString() + ', badge=' + this.r2b_1.toString() + ', name=' + this.s2b_1 + ', email=' + this.t2b_1 + ', callSignAdjective=' + this.u2b_1 + ', callSignNoun=' + this.v2b_1 + ', imageURL=' + this.w2b_1 + ', avatarType=' + toString(this.x2b_1) + ', additionalEmails=' + toString_0(this.y2b_1) + ')';
      }
      hashCode() {
        var result = this.q2b_1.hashCode();
        result = imul(result, 31) + this.r2b_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s2b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t2b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u2b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v2b_1) | 0;
        result = imul(result, 31) + (this.w2b_1 == null ? 0 : getStringHashCode(this.w2b_1)) | 0;
        result = imul(result, 31) + (this.x2b_1 == null ? 0 : this.x2b_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.y2b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Player()))
          return false;
        if (!this.q2b_1.equals(other.q2b_1))
          return false;
        if (!this.r2b_1.equals(other.r2b_1))
          return false;
        if (!(this.s2b_1 === other.s2b_1))
          return false;
        if (!(this.t2b_1 === other.t2b_1))
          return false;
        if (!(this.u2b_1 === other.u2b_1))
          return false;
        if (!(this.v2b_1 === other.v2b_1))
          return false;
        if (!(this.w2b_1 == other.w2b_1))
          return false;
        if (!equals(this.x2b_1, other.x2b_1))
          return false;
        if (!equals(this.y2b_1, other.y2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Player');
    PlayerClass = $;
  }
  return PlayerClass;
}
function get_emails(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  return plus(listOf(_this__u8e3s4.t2b_1), _this__u8e3s4.y2b_1);
}
function get_displayName(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  // Inline function 'kotlin.text.ifBlank' call
  var this_0 = _this__u8e3s4.s2b_1;
  var tmp;
  if (isBlank(this_0)) {
    tmp = 'Unknown';
  } else {
    tmp = this_0;
  }
  return tmp;
}
var properties_initialized_Player_kt_56shkt;
function _init_properties_Player_kt__qi83pd() {
  if (!properties_initialized_Player_kt_56shkt) {
    properties_initialized_Player_kt_56shkt = true;
    // Inline function 'kotlin.getOrThrow' call
    var this_0 = toNotBlankString('DEFAULT');
    throwOnFailure(this_0);
    var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).o29_1;
    defaultPlayer = new (Player())(new (PlayerId())(tmp$ret$0), Badge_Default_getInstance(), '', '', '', '', null, null, emptySet());
  }
}
//region block: exports
export {
  Player as Playerp02wk6dh65n2,
  get_defaultPlayer as get_defaultPlayer3nrcomik61lqf,
  get_displayName as get_displayName1mxts16oy93j,
  get_emails as get_emails2rmi4cgqmce4k,
};
//endregion

//# sourceMappingURL=Player.mjs.map
